import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui';
import { lastOrg, useOrgs } from '@/lib/hooks';

/** Sends people to their last organization, or to onboarding. */
export function HomeRedirect() {
  const { orgs, ready } = useOrgs();
  if (!ready) {
    return (
      <div className="flex justify-center py-24 text-muted">
        <Spinner />
      </div>
    );
  }
  if (orgs.length === 0) return <Navigate to="/new-org" replace />;
  const last = lastOrg();
  const target = orgs.find((o) => o.id === last) ?? orgs[0];
  return <Navigate to={`/orgs/${target.id}`} replace />;
}
